import { Button } from 'primereact/button'
import styled, { css } from 'styled-components'

/* ########## Reservation Modal - Footer Components ############ */
export const ActionArea = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: -4px;
  margin-top: 20px;
  border-bottom-right-radius: 15px !important;
  border-bottom-left-radius: 15px !important;
`
export const CancelButton = styled(Button)`
  width: 255px !important;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;

  :disabled {
    opacity: 0.4;
  }
`
export const ConfirmButton = styled(Button)`
  width: 255px !important;
  height: 50px;
  justify-content: center;
  background: #45bfe5;
  border-radius: 10px;
`

/* ########## Reservation Modal Header Components ############ */
export const HeaderInfo = styled.div`
  margin: 1rem 0 0.5rem 0;
  display: flex;
  justify-content: space-between;
  // align-items: flex-start;

  .coiffeur-info {
    position: relative;
    max-width: 400px;
    display: flex;
    align-items: flex-start;

    .slider-left-arrow {
      position: absolute;
      top: 0;
      left: 0;
    }

    .slider-right-arrow {
      position: absolute;
      top: 0;
      right: 0;
    }

    .coiffeur-photo {
      width: 55px;
      height: 55px;
      margin: 0 12px 0 40px;
    }

    .coiffeur-summary {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 5px;
      margin-right: 40px;

      .coiffeur-info-text {
        font-size: 12px;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .coiffeur-name-surname {
        font-size: 14px;
        font-weight: 700;
      }
    }
  }

  .coiffeur-explanation {
    flex-grow: 1;
    font-size: 12px;
    max-width: 560px;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
  }

  .calendar-notify {
    margin: 1rem 0;
    font-size: 14px;
    color: #222e47;
    line-height: 17px;
    font-weight: 700;
  }

  .appointment-date {
    min-width: 265px;
  }
`

/* ########## Reservation Scheduler Components ############ */
export const HeaderWrapper = styled.div`
  display: flex;
  width: calc(100% - 10px);
  border: 1px solid #ebebeb;
  border-radius: 4px;
`
export const DayHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-grow: 1;
  height: 40px;
  font-size: 14px;
  line-height: 17px;
  font-weight: 700;
  color: #363636;

  ${({ selected }: { selected: boolean }) =>
    selected &&
    css`
      background: #e3f5fb;
      border-bottom: 1px solid #ebebeb;
    `}
`
export const GridWrapper = styled.div`
  overflow-y: auto;
  max-height: calc(100% - 240px);
  width: calc(100% - 6px) !important;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: none !important;
    background-color: #d3d3d3 !important;
  }

  &::-webkit-scrollbar {
    height: 6px;
    width: 6px !important;
    background-color: #d3d3d3;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #7c7c7c;
  }
`
export const GridContainer = styled.div`
  display: flex;
  padding: 0px;
`
export const GridItem = styled.div`
  display: flex;
  padding: 0 10px;
  width: 100%;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-right: 1px solid #ebebeb;

  .selected {
    background: #45bfe5 !important;
    color: #fff !important;
  }

  &:last-child {
    border-right: none;
  }
`
export const TimeButton = styled(Button)`
  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed !important;
      border: none !important;
    `}

  cursor: pointer;
  padding: 0;
  margin: 5px 0;
  width: 100%;
  height: 30px;
  background: #ffffff;
  border: 0.5px solid #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.06);
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  color: #363636;

  &:disabled {
    opacity: 0.4 !important;
  }

  &:hover {
    background: #45bfe5 !important;
    color: #fff !important;
  }
`

/* ########### Schedule Sidebar Components ############ */
export const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ContentArea = styled.div`
  flex-grow: 1;
`

export const SidebarActionArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
  padding: 1rem 0 0.5rem;
`

export const Header = styled.div`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 1rem;
`
export const ReservationSummary = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: #222e47;
`
export const ImagePreview = styled.div`
  background: ${(props: { url: string }) => `url(${props.url})`};
  width: 150px;
  height: 150px;
  margin: 10px 0;
`

export const InfoList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;

  .reservation-subtitle {
    font-size: 1rem !important;
    font-weight: 700;
    line-height: 19px;
  }
`

export const InfoListItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  font-size: 14px;
  line-height: 17px;

  img {
    width: 20px;
    height: 20px;
  }

  .reservation-info-title {
    font-weight: 700;
    white-space: nowrap;
  }

  .reservation-info-value {
    word-break: break-words;
    word-wrap: break-word;
  }
`

export const SidebarCancelButton = styled(Button)`
  width: 100%;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
`
export const SidebarConfirmButton = styled(Button)`
  width: 100%;
  height: 50px;
  background: #45bfe5;
  border-radius: 10px;
  justify-content: center;
`
